import React from "react";
import { generateUniqueID } from "web-vitals/dist/modules/lib/generateUniqueID";
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";

import Services from "./components/services/services";
import Category from "./components/category/category";
import Projects  from  '../src/data/projects.json';



function App() {
  return (
      <Router>
        <Switch>
          <Route exact path="/services" component={Services}/>
          {
            Object.entries(Projects).map(project => {
              const tag = project[0];
              return (
                  <Route exact key={generateUniqueID()} path={"/services/" + tag}>
                    <Category tag={tag} />
                  </Route>
              );
            })
          }
        </Switch>
      </Router>
  );
}

export default App;
